<template lang="html">
  <div class="s-case-studies">
    <section-intro heading="case studies"></section-intro>

    <ul class="case-studies">
      <li @click="selectCase(caseStudy)" v-for="caseStudy in caseStudies">
        <img :src="caseStudy.thumb" alt="">
        <div class="case-study">
          <h4>{{ caseStudy.title }}</h4>
          <div class="cs__desc">
            <span></span>
            <div v-html="caseStudy.desc"></div>
          </div>
          <span>{{ caseStudy.client }}</span>
          <div class="cs__indicator">
            <img src="/static/svg/plus.svg" alt="">
            <img src="/static/svg/arrow-right-md.svg" alt="">
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import { CASE } from '@/store/mutation-types'
  import { mapGetters } from 'vuex'
  import SectionIntro from '@/components/SectionIntro'
  export default {
    components: {
      'section-intro': SectionIntro
    },
    name: 'case-studies',
    data () {
      return {

      }
    },
    computed: {
      ...mapGetters([
        'caseStudies'
      ])
    },
    methods: {
      selectCase (caseStudy) {
        this.$store.commit(CASE, caseStudy)
        this.$router.push({ name: 'cs', params: {cs: caseStudy.slug} })
      }
    }
  }
</script>

<style lang="scss">
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .s-case-studies {
    padding-bottom: 5rem;
  }

  .case-studies {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(18.687rem, 1fr));
    grid-auto-rows: minmax(auto, 18.687rem);
    grid-gap: 0.063rem;
    list-style-type: none;
    margin: 0;
    padding: 0;
    > li {
      position: relative;
      overflow: hidden;
      @include breakpoint(max-width $sm) {
        &:nth-child(n+5) {
          display: none;
        }
      }
      &:hover {
        > img {
          transform: scale(1.1);
        }
      }
      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        object-fit: cover;
        object-position: 50% 50%;
        transition: 0.3s ease;
      }
    }
  }

  .case-study {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1.5rem;
    background-color: rgba($dark-blue, 0.5);
    color: $white;
    transition: background 0.3s ease;
    &:hover {
      background-color: rgba($dark-red, 0.5);
      cursor: pointer;
      .cs__desc {
        visibility: visible;
      }
      .cs__indicator {
        background-color: $white;
        img:nth-child(1) {
          display: none;
        }
        img:nth-child(2) {
          display: block;
        }
      }
    }
    h4 {
      margin: 0;
      font-family: $barlowCondensed;
      font-size: 2rem;
      font-weight: 400;
      line-height: 1;
    }
    > span {
      font-family: $montserrat;
      font-size: 0.800rem;
      font-weight: 500;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
  }

  .cs__desc {
      position: relative;
      visibility: hidden;
      font-size: 0.9rem;
      color: $white;
      span {
        position: absolute;
        display: block;
        margin-bottom: 50px;
        width: 50px;
        height: 0.063rem;
        background-color: $white;
      }
    }

  .cs__indicator {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 1.5rem;
    right: 1.5rem;
    height: 2.688rem;
    width: 2.688rem;
    padding: 1rem;
    border: 0.063rem solid $white;
    border-radius: 100%;
    background-color: transparent;
    img:nth-child(2) {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/CaseStudies.vue